// extracted by mini-css-extract-plugin
module.exports = {"messageRemove":"RemoveQueueItemModal-messageRemove-2hpG1"};